import React, { useContext, useEffect, useState } from 'react';
import welcomeContainer from '../assets/Welcome container (1).png';
import { Card, Spinner } from 'flowbite-react';
import banner from '../../assets/Welcome container.png'
import { url } from 'inspector';
import { FaArrowRight } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import * as styles from './overview.styles'
import CustomLink from '../../components/CustomLinks/CustomLink';
import CustomButton from '../../components/CustomButton/CustomButton';
import WelcomeCard from '../../components/WelcomeCard/WelcomeCard';
import PrivateLayout from '../../layouts/PrivateLayout/PrivateLayout';
import { UserContext } from '../../contexts/UserContext';
import backgroundImage from '../../assets/backgroundImageCard.png'
import client from '../../api/client';

const Overview = () => {
  const { userDetails } = useContext(UserContext) ?? {}
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [onboardingStatus, setOnboardingStatus] = useState<{
    allZero: boolean;
    route: string;
  } | null>(null)

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      try {
        setLoading(true)
        const response = await client.get("/subsidiary/dashboard/onboarding/percentage");
        if (response.data.status === "success") {
          const percentages = response.data.data;
          const allZero = Object.entries(percentages)
            .filter(([key]) =>
              ["personalInformation", "businessInformation", "businessCompliance", "bankInformation", "termsAndCondition"].includes(key)
            )
            .every(([, value]: any) => parseFloat(value) === 0);

          setOnboardingStatus({
            allZero,
            route: allZero ? '/business/onboarding' : '/business/onboarding/kyc'
          });
        }
      } catch (err: any) {
        console.error('Error checking onboarding status:', err);
      } finally {
        setLoading(false)
      }
    };

    checkOnboardingStatus();
  }, []);

  const handleNavigation = () => {
    console.log(onboardingStatus);
    
    if (onboardingStatus) {
      navigate(onboardingStatus.route);
    }
  };
  
  return (
      <div className={styles.container}>
        <div className={styles.bannerContainer} style={{ backgroundImage: "url('Welcome container (1).png')" }}>
          <div className={styles.banner}>
            <p className={styles.bannerTitle}>Welcome onboard, <span className="italic">{userDetails.activeSubsidiary.businessName}</span></p>
            <div className={styles.bannersubtitle}>
              <p className={styles.bannersubtitleTxt}>Your trusted payment gateway! Enjoy swift, reliable payments backed by top-notch security measures</p>
            </div>
            <div className={styles.bannerButtonContainer}>
            <CustomButton
              className={styles.bannerButton}
              icon={<FaArrowRight />}
              onClick={handleNavigation}
              text='Start Transacting'
              disabled={loading}
            />
          </div>
          </div>
        </div>

        <div className={styles.getStartedContainer}>
          <p className={styles.welcomeMessage}>👋 Hello!<span className="font-bold"> Get Started with Ideospay</span></p>
          <p className={styles.welcomeText}>Here's a few things to help you get started as a business on Ideospay</p>
        </div>
        <hr />

          <div className={styles.gridContainer}>
        <WelcomeCard
          flexDirection='row'
          title='Complete Profile Setup'
          route='/business/onboarding'
          comment="Here's a few things to help you get started as a business on Ideospay"
          buttonText='Complete'
          handleClick={handleNavigation}
        />
        <WelcomeCard
          flexDirection='row'
          title='API Documentation'
          route="#"
          comment="Integrate Ideospay with our developer documentation which contains the Libraries, APIs and SDKs."
          buttonText='View Documentation'
          handleClick={() => window.open("https://documenter.getpostman.com/view/10904236/2sA35G539D", '_blank', 'noopener,noreferrer')}
        />
        </div>

        <div className={styles.marginTop}>
          <div className={styles.gridContainer}>
          <WelcomeCard
            flexDirection='col'
            title='Setup 2FA Security'
            route={"#"}
            comment="Protect your account with 2-factor authentication"
            buttonText='Complete'
            handleClick={()=>{}}
          />
          <WelcomeCard
            className="bg-black"
            flexDirection='col'
            title='Get an online store'
            route=''
            handleClick={()=>{}}
            buttonBgColor='bg-black'
            buttonTextColor='text-white'
            backgroundImage={backgroundImage}
            comment='Create a professionally designed online store in less than 1min'
            buttonText='Create your store'
          />
        </div>
      </div>
    </div>
  );
};

export default Overview;
